export const MAC_EFFECTS_HELP = {
  title: "Background effects on Mac",
  steps: [
    "Turn your camera on.",
    "Click the green camera icon in the macOS menu bar.",
    "Enable Portrait to blur your background, or Background to replace it, if available.",
  ],
  note: "To blur your real surroundings, turn Background off and Portrait on. These controls are managed by macOS.",
  ventura: "On Ventura: Control Center → Video Effects → Portrait.",
};

const unknownBlur = { controllable: false, known: false, on: null };

/** Desktop Mac, not iPhone/iPad (including iPadOS, which reports as MacIntel). */
export function isDesktopMac(nav) {
  if (!nav) return false;
  const ua = nav.userAgent || "";
  const iPad = nav.platform === "MacIntel" && nav.maxTouchPoints > 1;
  if (/iPhone|iPad|iPod/i.test(ua) || iPad) return false;
  return /Macintosh|Mac OS X/i.test(ua);
}

// Chrome asks the OS camera driver to blur. Hide the control unless this
// track reports both true and false, which is the only case the page can toggle.
export function blurControl(track) {
  const values = track?.getCapabilities?.().backgroundBlur;
  const controllable = Array.isArray(values) && values.includes(true) && values.includes(false);
  if (!controllable) return null;
  return { on: track.getSettings?.().backgroundBlur === true };
}

/** Controllable, read-only, or unknown. A missing setting is unknown, not off. */
export function blurStatus(track) {
  const values = track?.getCapabilities?.().backgroundBlur;
  const listed = Array.isArray(values) ? values : [];
  const controllable = listed.includes(true) && listed.includes(false);
  const setting = track?.getSettings?.()?.backgroundBlur;
  const known = typeof setting === "boolean";
  if (!controllable && !known) return { ...unknownBlur };
  return { controllable, known: true, on: setting === true };
}

export async function setBackgroundBlur(track, on) {
  if (!blurControl(track)) throw new Error("Background blur is not supported");
  await track.applyConstraints({ backgroundBlur: !!on });
  return track.getSettings?.().backgroundBlur === true;
}
